// src/app/constants/brand-constants.ts
import { TrendingUp, TrendingDown, Minus, type LucideIcon } from "lucide-react";

export const FALLBACK_MODEL = {
  model: "unknown",
  score: 0,
  rank: 0,
  velocity: 0,
  velocityColor: "var(--muted-foreground)",
  accuracyRisk: "Unknown",
  riskColor: "warning" as const,
};

// Map velocity strings to Icons
export const VELOCITY_ICONS: Record<string, LucideIcon> = {
  rising: TrendingUp,
  falling: TrendingDown,
  stable: Minus,
  default: Minus,
};

export const PROVIDER_LABEL: Record<string, string> = {
  openai: "OpenAI",
  claude: "Claude",
  perplexity: "Perplexity",
  gemini: "Gemini",
  copilot: "Copilot",
  google: "Google",
};